document.addEventListener("DOMContentLoaded", () => {
  const openModalBtn = document.getElementById("open-color-picker");
  const modal = document.getElementById("color-picker-modal");
  const modalContent = modal.getElementsByClassName("color-picker-modal-content")[0];
  const confirmBtn = document.getElementById("confirm-color");
  const wallOverlay = document.getElementById("wall-overlay");
  const colorList = document.getElementById("color-list");
  const selectedColorName = document.getElementById("selected-color-label-name");
  const modalSelectedColorInfo = document.getElementById("modal-selected-color-info");
  const searchInput = document.getElementById("color-search");
  const toggleSearchButton = document.getElementById("toggle-search");
  const selectedColorPropertyInput = document.getElementById("selected-color-property");
  const selectedColorIdInput = document.getElementById("selected-color-id");
  const radioButtons = document.querySelectorAll('input[name="Farbe"]');
  const resetColorButton = document.getElementById("reset-color-button");

  let colors = [];
  let tempSelectedColor = null;
  let selectedCategory = null;

  // Sicherheitsprüfung für DOM-Elemente
  function validateDOMElements() {
    const missingElements = [];
    if (!selectedColorName) missingElements.push("selectedColorName");
    if (!selectedColorPropertyInput) missingElements.push("selectedColorPropertyInput");
    if (!selectedColorIdInput) missingElements.push("selectedColorIdInput");
    if (!modalSelectedColorInfo) missingElements.push("modalSelectedColorInfo");
    if (!searchInput) missingElements.push("searchInput");
    if (!toggleSearchButton) missingElements.push("toggleSearchButton");
    if (!modal) missingElements.push("modal");
    if (!modalContent) missingElements.push("modalContent");
    if (!confirmBtn) missingElements.push("confirmBtn");
    if (!colorList) missingElements.push("colorList");

    if (missingElements.length > 0) {
      console.error(`Fehlende DOM-Elemente: ${missingElements.join(", ")}`);
      return false;
    }
    return true;
  }

  // Standardfarbe (weiß)
  function setDefaultColor() {
    if (!validateDOMElements()) return;

    const defaultColor = { name: "weiß", priceGroup: "weiß", hex: "#FFFFFF", id: "default" };
    tempSelectedColor = defaultColor;

    // Wähle den Radio-Button für "weiß" aus
    radioButtons.forEach((radio) => {
      if (radio.value === "weiß") {
        radio.click();
      }
    });

    updateProductSelectedColorInfo(defaultColor);
  }

  // Aktualisiere die Farbinformationen im Produkt
  function updateProductSelectedColorInfo(color) {
    if (!validateDOMElements()) return;

    selectedColorName.innerHTML = `
      <div class="color-circle" style="background-color: ${color.hex}; display: inline-block; width: 12px; height: 12px; border-radius: 50%; margin: 0 6px; vertical-align: text-bottom;"></div>
      ${color.name}
    `;
    selectedColorPropertyInput.value = color.name;
    selectedColorIdInput.value = color.id;
  }

  // Wähle den passenden Radio-Button für die Farbe
  function selectRadioButtonForColor(color) {
    let radioFound = false;

    radioButtons.forEach((radio) => {
      if (radio.dataset.priceGroup === `PG${color.priceGroup}`) {
        radio.click();
        radioFound = true;

        selectedColorPropertyInput.value = color.name;
        selectedColorIdInput.value = color.id;
      }
    });

    if (!radioFound) {
      console.error(`Kein Radio-Button für die Preisklasse PG${color.priceGroup} gefunden.`);
    }
  }


  // Event Listener für den Zurücksetzen-Button (weiß)
  resetColorButton.addEventListener("click", () => {
    setDefaultColor();
  });

  // Funktion zum Rendern der Kategorien
  function renderCategories(categories) {
    const categoryContainer = document.getElementById("color-categories");

    if (!categoryContainer) {
      console.error("Das Element für die Kategorien fehlt.");
      return;
    }

    categoryContainer.innerHTML = "";

    categories.forEach((category) => {
      const button = document.createElement("button");
      button.textContent = category;
      button.className = "category-button";
      button.addEventListener("click", () => {
        selectedCategory = category;
        renderColors();
        document.querySelectorAll(".category-button").forEach((btn) => btn.classList.remove("active"));
        button.classList.add("active");
      });
      categoryContainer.appendChild(button);
    });

    if (categories.length > 0) {
      selectedCategory = categories[0];
      categoryContainer.firstChild.classList.add("active");
      renderColors();
    }
  }

  // Funktion zum Rendern der Farben
  function renderColors(searchQuery = "") {
    colorList.innerHTML = ""; // Leere die Liste

    // Filtere die Farben basierend auf der Suchanfrage und der Kategorie
    const filteredColors = colors.filter((color) => {
      const matchesSearch = color.name.toLowerCase().includes(searchQuery.toLowerCase());
      const matchesCategory = selectedCategory ? color.category === selectedCategory : true;
      return searchQuery ? matchesSearch : matchesCategory;
    });

    // Füge die gefilterten Farben zur Liste hinzu
    filteredColors.forEach((color) => {
      const chip = document.createElement("div");
      chip.className = "color-chip";
      chip.style.backgroundColor = color.hex;
      chip.title = `${color.name} (${color.id})`;
      chip.addEventListener("click", () => {
        tempSelectedColor = color;
        wallOverlay.style.backgroundColor = color.hex;
        updateModalSelectedColorInfo();
      });
      colorList.appendChild(chip);
    });

    // Zeige eine Nachricht an, wenn keine Farben gefunden wurden
    if (filteredColors.length === 0) {
      colorList.innerHTML = "<p>Keine Farben gefunden.</p>";
    }
  }

  // Funktion zum Aktualisieren der Farbinformationen im Modal
  function updateModalSelectedColorInfo() {
    if (!tempSelectedColor) return;

    modalSelectedColorInfo.innerHTML = `
      <div class="modal-color-preview" style="background:${tempSelectedColor.hex}; width: 12px; height: 12px; border-radius: 50%; display: inline-block; margin: 0 6px; vertical-align: text-bottom;"></div>
      <strong>${tempSelectedColor.name}</strong> — PG${tempSelectedColor.priceGroup}
    `;
  }

  // Event Listener für das Öffnen des Modals
  openModalBtn.addEventListener("click", () => {
    modal.classList.remove("hidden");
  });

  // Event Listener für das Schließen des Modals bei Klick außerhalb
  modal.addEventListener("click", (e) => {
    if (!modalContent.contains(e.target)) {
      modal.classList.add("hidden");
    }
  });

  // Event Listener für die Bestätigung der Farbauswahl
  confirmBtn.addEventListener("click", () => {
    if (!tempSelectedColor) return;

    updateProductSelectedColorInfo(tempSelectedColor);
    selectRadioButtonForColor(tempSelectedColor);
    modal.classList.add("hidden");
  });

  // Event Listener für das Such-Icon
  toggleSearchButton.addEventListener("click", () => {
    if (searchInput.classList.contains("visible")) {
      searchInput.classList.remove("visible");
    } else {
      searchInput.classList.add("visible");
      searchInput.focus(); // Setze den Fokus auf das Suchfeld
    }
  });

  // Event Listener für die Suche
  searchInput.addEventListener("input", (e) => {
    const searchQuery = e.target.value.toLowerCase();
    renderColors(searchQuery); // Aktualisiere die Farbliste basierend auf der Eingabe
  });

  // Lade die Farben und Kategorien
  fetch(COLORS_JSON_URL)
    .then((res) => res.json())
    .then((data) => {
      colors = data;
      const categories = [...new Set(colors.map((color) => color.category))];
      renderCategories(categories);
      renderColors();
    })
    .catch((err) => {
      console.error("Fehler beim Laden der Farben:", err);
    });

  // Sicherheitsprüfung
  if (!validateDOMElements()) return;

  // Initialisiere Standardfarbe und andere Funktionen
  setDefaultColor();
});